import { useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { templatesModel, SelectEventType } from '../../../features/templates';
import { TemplateSharingAccess } from '@distribute/shared/types';

import { pageCreationFlowModel } from '../../../processes/page-creation-flow';
import { PageCreationFlowStepsEnum } from '../../../processes/page-creation-flow/config/types';
import { TemplateExtended } from '@distribute/shared/api-types/templates';

export const useTemplatesActions = () => {
  const [isDeleteTemplateModalOpen, setIsDeleteTemplateModalOpen] =
    useState(false);

  const [isTemplateSettingsModalOpen, setIsTemplateSettingsModalOpen] =
    useState(false);

  const [currentTemplate, setCurrentTemplate] =
    useState<TemplateExtended | null>(null);

  const dispatch = useDispatch();

  const createPageIsLoading = useSelector(
    pageCreationFlowModel.selectors.selectCreatePageIsLoading
  );

  const createBlankTemplateIsLoading = useSelector(
    templatesModel.selectors.selectCreateBlankTemplateIsLoading
  );

  const handleClickBrowseTemplates = () => {
    dispatch(
      pageCreationFlowModel.actions.openPageCreationFlow({ mode: 'template' })
    );
  };

  const handleClickChooseTemplate = useCallback(() => {
    dispatch(pageCreationFlowModel.actions.openPageCreationFlow({}));
    dispatch(
      pageCreationFlowModel.actions.setCurrentStep(
        PageCreationFlowStepsEnum.CREATE_PAGE
      )
    );
  }, [dispatch]);

  const handleCreateTemplate = useCallback(
    ({ hasMultiTabs }: SelectEventType) => {
      dispatch(
        templatesModel.actions.createBlankTemplate({
          sharingAccess: TemplateSharingAccess.PERSONAL,
          isSinglePage: !hasMultiTabs,
        })
      );
    },
    [dispatch]
  );

  const handleOpenDeleteTemplateModal = useCallback(
    (template: TemplateExtended) => {
      setCurrentTemplate(template);
      setIsDeleteTemplateModalOpen(true);
    },
    []
  );

  const handleOpenTemplateSettingsModal = useCallback(
    (template: TemplateExtended) => {
      setCurrentTemplate(template);
      setIsTemplateSettingsModalOpen(true);
    },
    []
  );

  const handleCloseDeleteTemplateModal = useCallback(() => {
    setIsDeleteTemplateModalOpen(false);
    setCurrentTemplate(null);
  }, []);

  const handleCloseTemplateSettingsModal = useCallback(() => {
    setIsTemplateSettingsModalOpen(false);
    setCurrentTemplate(null);
  }, []);

  return {
    isDeleteTemplateModalOpen,
    isTemplateSettingsModalOpen,
    currentTemplate,
    handleClickBrowseTemplates,
    handleClickChooseTemplate,
    handleCreateTemplate,
    handleOpenDeleteTemplateModal,
    handleOpenTemplateSettingsModal,
    handleCloseDeleteTemplateModal,
    handleCloseTemplateSettingsModal,
    createPageIsLoading,
    createBlankTemplateIsLoading,
  };
};
